import { Quest } from '../services/QuestsService.schemas';

export const isValidOptInPromo = (promo: Quest | null): boolean =>
  promo?.promoType !== 'Welcome' &&
  (promo?.promoType === 'Cashback' ||
    promo?.promoType === 'Action' ||
    promo?.promoType === 'InPeriod');
